import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeLogs from "./PrimeLogs";
import PrimePhilippinesOrderFlowDetails from "./PrimePhilippinesOrderFlowDetails";
import PrimePhilippinesUserDetails from "./PrimePhilippinesUserDetails";

interface PrimeDetailsPhilippinesTabsProps {
  instanceId: string;
}

const PrimeDetailsPhilippinesTabs: React.FC<
  PrimeDetailsPhilippinesTabsProps
> = ({ instanceId }) => {
  const tabs = [
    {
      label: "TRADE",
      component: <PrimePhilippinesOrderFlowDetails instanceId={instanceId} />,
    },
    {
      label: "USER",
      component: <PrimePhilippinesUserDetails instanceId={instanceId} />,
    },
    {
      label: "LOGS",
      component: (
        <PrimeLogs
          instanceId={instanceId}
          endPoint="/adminPanel/getPHPCallbackLogs"
          sendCallbackEndPoint="/adminPanel/sendPHPCallbackForLog"
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsPhilippinesTabs;
